/**
 * @method setAlertModal
 * @method setLoadingModal
 * @method setConfirmModal
 * @method setTermsModal
 * Redeem
 * @method setConfirmRedeemModal
 * @method setSerialModal
 * @method setRedeemSuccessModal
 */
export function ModalController() {
    //#region generic
    this.alertModal = null;
    this.confirmModal = null;
    this.errorModal = null;
    this.loadingModal = null;
    this.noInternetModal = null;
    this.successModal = null;
    this.termsModal = null;
    this.copySuccessToast = null;

    this.setAlertModal = function (alertModalController) {
        this.alertModal = alertModalController;
    };

    this.setConfirmModal = function (confirmModalController) {
        this.confirmModal = confirmModalController;
    };

    this.setErrorModal = function (errorModalController) {
        this.errorModal = errorModalController;
    };

    this.setLoadingModal = function (loadingModalController) {
        this.loadingModal = loadingModalController;
    };

    this.setNoInternetModal = function (noInternetModalController) {
        this.noInternetModal = noInternetModalController;
    };

    this.setSuccessModal = function (successModalController) {
        this.successModal = successModalController;
    }

    this.setTermsModal = function (termsModalController) {
        this.termsModal = termsModalController;
    };

    this.setCopySuccessToast = function (copySuccessToastController) {
        this.copySuccessToast = copySuccessToastController;
    };
    //#endregion generic

    //#region redeem
    this.confirmRedeemModal = null;
    this.drawDeliveryModal = null;
    this.redeemSuccessModal = null;
    this.serialModal = null;

    this.setConfirmRedeemModal = function (confirmRedeemModal) {
        this.confirmRedeemModal = confirmRedeemModal;
    };

    this.setDrawDeliveryModal = function (drawDeliveryModal) {
        this.drawDeliveryModal = drawDeliveryModal;
    };

    this.setRedeemSuccessModal = function (redeemSuccessModal) {
        this.redeemSuccessModal = redeemSuccessModal;
    };

    this.setSerialModal = function (serialModal) {
        this.serialModal = serialModal;
    };
    //#endregion redeem
}
